import { memo } from 'react';
import { useGetLicense } from 'react-easyrocket';
import { AllRights } from 'src/svg/AllRights';

const _FooterLicenseBlock = () => {
  const { image: licenseImage, text: licenseText } = useGetLicense();

  return (
    <div className="flex flex-col items-center 768:flex-row gap-5 justify-between mt-7">
      <p className="font-medium text-xs text-f_license flex-1 text-left">{licenseText}</p>
      <div className="flex shrink-0 items-center gap-4">
        <div
          dangerouslySetInnerHTML={{ __html: licenseImage }}
          className="[&_img]:flex [&_img]:shrink-0 [&_img]:w-auto [&_img]:object-contain [&_img]:max-w-[100px] [&_img]:h-[50px]"
        />
        <div className="max-w-[50px] min-w-[50px] object-contain">
          <AllRights />
        </div>
      </div>
    </div>
  );
};

export const FooterLicenseBlock = memo(_FooterLicenseBlock);
